module.exports = __webpack_public_path__ + "img/51_38.ecc00800.png";